import apiClient from "../apiClient";

const resource = "bookPatients";

export default {
    addPatient: payload => apiClient.post(`${resource}/patient`, payload),
    addAppointment: payload => apiClient.post(`${resource}/appointment`, payload),
    addPayment: (id,payload) => apiClient.post(`${resource}/${id}/payment`, payload),
   
};
